import './Header.css';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, NavLink, withRouter } from 'react-router-dom';
import { Collapse, NavbarToggler } from 'reactstrap';

import misc from '../../misc';
import auth from '../../auth';

export class Header extends Component {
  constructor(props) {
    super(props);

    this.toggle = this.toggle.bind(this);
    this.state = {
      isOpen: false
    };
  }

  toggle() {
    this.setState({
      isOpen: !this.state.isOpen
    });
  }

  handleLogout = event => {
    this.props.logout(this.props.history);
  };

  /*
  renderContent() {
    switch (this.props.auth) {
      case null:
        return;
      case false:
        return (
          <li>
            <a href="/api/auth/google">Signup / Login</a>
          </li>
        );
      default:
        return (
          <div>
            <li>
              {this.props.auth.firstName} ({this.props.auth.email})
            </li>
            <li>
              <a href="/api/auth/logout">Logout</a>
            </li>
          </div>
        );
    }
  }
  */

  renderNavbarBrand() {
    const { pathname } = this.props.location;
    let headerLink, headerName;
    if (pathname.startsWith('/clients')) {
      headerLink = '/clients';
      headerName = 'Clients';
    } else if (pathname.startsWith('/sessions')) {
      headerLink = '/sessions';
      headerName = 'Schedule';
    } else if (pathname.startsWith('/payments')) {
      headerLink = '/payments';
      headerName = 'Payments';
    } else if (pathname.startsWith('/settings')) {
      headerLink = '/settings';
      headerName = 'Settings';
    } else {
      headerLink = '/dashboard';
      headerName = 'Personal Trainer';
    }
    return (
      <Link to={headerLink} className="navbar-brand d-xs-block d-md-none">
        <img
          src={misc.images.logoGrey5}
          width="30"
          height="30"
          className="d-inline-block align-top mr-3"
          alt="Federation"
        />
        {headerName}
      </Link>
    );
  }

  render() {
    return (
      <div className="col-md-3">
        <nav className="navbar navbar-expand-md navbar-light bg-light mb-4">
          {this.renderNavbarBrand()}

          <NavbarToggler onClick={this.toggle} />
          <Collapse isOpen={this.state.isOpen} navbar>
            <ul className="navbar-nav flex-column">
              <img
                src={misc.images.logoGrey5}
                width="30"
                height="30"
                className="d-none d-md-block"
                alt="Federation"
              />
              <li className="nav-item mt-3">
                <NavLink
                  to="/sessions"
                  onClick={this.toggle}
                  className="nav-link"
                >
                  Schedule
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/clients"
                  onClick={this.toggle}
                  className="nav-link"
                >
                  Clients
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/payments"
                  onClick={this.toggle}
                  className="nav-link"
                >
                  Payments
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  to="/settings"
                  onClick={this.toggle}
                  className="nav-link"
                >
                  Settings
                </NavLink>
              </li>
              <li className="nav-item">
                <a className="nav-link" onClick={this.handleLogout}>
                  Logout
                </a>
              </li>
            </ul>
            <hr className="visible-xs mt-3" />
          </Collapse>
        </nav>
      </div>
    );
  }
}

export default withRouter(connect(null, { ...auth.actions })(Header));



// WEBPACK FOOTER //
// ./src/modules/core/components/Header.js